enum MeetingsType {
    INSTANT = 'INSTANT',
    SCHEDULED = 'SCHEDULED',
    RECURRING_NO_FIXED_TIME = 'RECURRING_NO_FIXED_TIME',
    WEBINAR = 'WEBINAR',
    RECURRING_WEBINAR_NO_FIXED_TIME = 'RECURRING_WEBINAR_NO_FIXED_TIME',
    RECURRING_FIXED_TIME = 'RECURRING_FIXED_TIME',
    RECURRING_WEBINAR_FIXED_TIME = 'RECURRING_WEBINAR_FIXED_TIME'
}

export { MeetingsType };